var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tips==2)?_c('div',{staticClass:"tips-box"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"有新的交易完成，请及时处理！","placement":"top-start"}},[(_vm.name=='transaction')?_c('i',{staticClass:"tips el-icon-warning"}):_vm._e()])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }